import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-twenty-five',
  templateUrl: './home-twenty-five.component.html',
  styleUrls: ['./home-twenty-five.component.scss']
})
export class HomeTwentyFiveComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
